export const isLoading = 'isLoading';
export const snackbar = 'snackbar';
export const isLoggedIn = 'isLoggedIn';
